export const ShopData = [
  {
    id: "abc",
    title: "Stress Balls",
    imgUrl:
      "https://images-na.ssl-images-amazon.com/images/I/51W3-YY%2BAcL._AC_.jpg",
    price: 9,
  },
  {
    id: "xyz",
    title: "Fidget Fingers",
    imgUrl:
      "https://static.boredpanda.com/blog/wp-content/uploads/2016/09/fidget-cube-antsy-labs-fb.png",
    price: 4,
  },
  {
    id: "adx",
    title: "Origins Peace of Mind",
    imgUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGna1UT4Y9JXVgutE_-Uk12ZH9FmeE-IBc9w&usqp=CAU",
    price: 13,
  },
  {
    id: "aft",
    title: "Vibrating Head Massager",
    imgUrl:
      "https://static.standard.co.uk/s3fs-public/thumbnails/image/2017/04/03/17/vibratingheadmassager.jpg?width=640&auto=webp&quality=75&crop=1000%3A1000%2Csmart",
    price: 8,
  },
  {
    id: "iuf",
    title: "The Art Therapy Colouring Book",
    imgUrl:
      "https://www.biblioimages.com/michaelomara/getimage.aspx?pdfdirect=DRm2feZrcyy7aB8ta5pWBA==&bibliologin=1&s=3cb3f2f5-e88a-4d09-aff9-16dab6bef3e0&cat=default&class=books&type=jpg&mode=&size=onix&id=5145",
    price: 9,
  },
  {
    id: "jys",
    title: "Neom Organics Real Luxury Scented Candle",
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0199/0456/1206/products/JustforYouRealLuxury3wick_750x750.jpg?v=1611563045",
    price: 30,
  },
  {
    id: "dal",
    title: "Dammit Dolls",
    imgUrl:
      "https://allairevillage.org/wp-content/uploads/2020/07/20200524_120827.jpg",
    price: 12,
  },
  {
    id: "adl",
    title: "Doctor You by Jeremy Howick",
    imgUrl:
      "https://images-na.ssl-images-amazon.com/images/I/51wsh8AVUpL._SX329_BO1,204,203,200_.jpg",
    price: 10,
  },
];
